// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SWKl","title":"styles_title__2eQEZ"};